/**
 * SCWT-PM-V2 Phase 7 · Slice E — shared LWH helpers.
 *
 * Central place for status → landlord-friendly label + tone
 * (server statuses are internal state-machine values — the landlord
 * must never see raw "cancel_at_period_end" text).
 */
export const LWH_LANDLORD_STATUS_LABEL = {
  not_enrolled:         "Not enrolled",
  pending_confirmation: "Invitation pending",
  pending_payment:      "Pending payment",
  active:               "Active",
  past_due:             "Payment issue",
  payment_failed:       "Payment issue",
  cancel_at_period_end: "Cancellation scheduled",
  cancelled:            "Ended",
  expired:              "Ended",
  suspended:            "Suspended",
  admin_review:         "Under review",
};

export const LWH_LANDLORD_STATUS_TONE = {
  not_enrolled:         "bg-slate-100 text-slate-700 border-slate-200",
  pending_confirmation: "bg-amber-50 text-amber-800 border-amber-200",
  pending_payment:      "bg-amber-50 text-amber-800 border-amber-200",
  active:               "bg-emerald-50 text-emerald-800 border-emerald-200",
  past_due:             "bg-rose-50 text-rose-800 border-rose-200",
  payment_failed:       "bg-rose-50 text-rose-800 border-rose-200",
  cancel_at_period_end: "bg-orange-50 text-orange-800 border-orange-200",
  cancelled:            "bg-slate-100 text-slate-700 border-slate-200",
  expired:              "bg-slate-100 text-slate-700 border-slate-200",
  suspended:            "bg-rose-50 text-rose-800 border-rose-200",
  admin_review:         "bg-cyan-50 text-cyan-800 border-cyan-200",
};

// Admin-facing labels retain the raw state-machine names because
// support engineers need them.
export const LWH_ADMIN_STATUS_LABEL = {
  pending_confirmation: "Pending confirmation",
  pending_payment:      "Pending payment",
  active:               "Active",
  past_due:             "Past due",
  payment_failed:       "Payment failed",
  cancel_at_period_end: "Cancel at period end",
  cancelled:            "Cancelled",
  expired:              "Expired",
  suspended:            "Suspended",
  admin_review:         "Admin review",
};

/** Currency + date helpers (mirror backend snapshots). */
export function centsToAud(cents) {
  const n = Number(cents || 0) / 100;
  return `AUD $${n.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function fmtDateAU(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-AU",
      { day: "numeric", month: "short", year: "numeric" });
  } catch { return iso; }
}

/** Every enrolment CTA links here. Kept centralised so the string
 *  can be renamed once (e.g. AWARE rebrand). */
export const LWH_ENROL_ROUTE = "/landlord/water-health/enrol";
